import { useQuery } from "@tanstack/react-query";
import api from "./__api__/element-query";

export const useQueryEcrfElementQuery = (ecrfId: string, elementId: string) => {
  return useQuery({
    queryKey: [api.getEcrfElementQueryPath(ecrfId, elementId)],
    queryFn: api.getEcrfElementQuery(ecrfId, elementId),
  });
};

export default { useQueryEcrfElementQuery };